import { createIcon } from '@chakra-ui/icons';

export const AuthoringFile = createIcon({
  displayName: 'AuthoringFile',
  viewBox: '0 0 44 44',
  path: [
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4799_22666)">
        <path
          d="M0.655762 22.0003C0.655762 38.4312 18.4427 48.7005 32.6724 40.485C39.2764 36.6722 43.3446 29.6259 43.3446 22.0003C43.3446 5.56935 25.5576 -4.70001 11.328 3.51549C4.72396 7.3283 0.655762 14.3747 0.655762 22.0003Z"
          fill="#FEF3DF"
        />
        <path
          d="M12.6704 33.9454C12.6701 34.2936 12.9525 34.576 13.3007 34.5757H31.5737C31.9217 34.5757 32.2037 34.2934 32.2034 33.9454V13.465L26.8474 8.10889H13.2991C12.9517 8.10976 12.6704 8.39169 12.6704 8.73913V33.9454Z"
          fill="white"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7915 19.8872H21.6745V25.7702H15.7915V19.8872Z"
          fill="#F6D59D"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.439 24.8882C23.4361 27.379 26.1307 28.9388 28.2892 27.6958C29.2933 27.1177 29.9116 26.0468 29.9102 24.8882C29.9131 22.3974 27.2185 20.8376 25.06 22.0805C24.0559 22.6587 23.4376 23.7296 23.439 24.8882Z"
          fill="#F6D59D"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6704 33.9454C12.6701 34.2936 12.9525 34.576 13.3007 34.5757H31.5737C31.9217 34.5757 32.2037 34.2934 32.2034 33.9454V13.465L26.8474 8.10889H13.2991C12.9517 8.10976 12.6704 8.39169 12.6704 8.73913V33.9454Z"
          stroke="#535353"
          strokeWidth="0.421821"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.2037 13.465H27.436C27.111 13.465 26.8477 13.2016 26.8477 12.8767V8.10889L32.2037 13.465Z"
          fill="#F6D59D"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2715 38.812C15.2715 39.5206 20.8966 39.9635 25.3967 39.6091C27.4853 39.4447 28.7719 39.1408 28.7719 38.812C28.7719 38.1034 23.1467 37.6605 18.6466 38.0148C16.5581 38.1793 15.2715 38.4832 15.2715 38.812Z"
          fill="#F1CA89"
        />
        <path
          d="M25.091 17.9183C25.0811 17.7249 24.8654 17.6146 24.7028 17.72C24.7026 17.7201 24.703 17.7199 24.7028 17.72L20.1575 20.6716C19.995 20.7772 20.0078 21.019 20.1805 21.1069L25.0087 23.5675C25.1815 23.655 25.3843 23.5231 25.3744 23.3297L25.091 17.9183Z"
          fill="#F6D59D"
        />
        <path
          d="M24.7028 17.72C24.8654 17.6146 25.0811 17.7249 25.091 17.9183L25.3744 23.3297C25.3843 23.5231 25.1815 23.655 25.0087 23.5675L20.1805 21.1069C20.0078 21.019 19.995 20.7772 20.1575 20.6716L24.7028 17.72ZM24.7028 17.72C24.7026 17.7201 24.703 17.7199 24.7028 17.72Z"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4799_22666">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
